<template>
  <label for="fixed-interest">{{$store.getters.translations.debit_interest_rate}}</label>
  <div class="select-wrapper">
    <select @change="emitChange($event)" name="fixed-interest" id="fixed-interest" form="">
      <option v-for="value in interests" v-bind:key="value.rate" :value="value.rate" :selected="year === value.year">{{value.year}} {{$store.getters.translations.years}}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "fixed-interest",
  props:{
    interests:{
      type:Array,
      required:true
    },
    year:{
      type:Number
    }
  },
  emits:[
    'change-fixed-interest'
  ],
  watch:{
    interest(value){
        console.log('interest changed',value);
    }
  },
  data(){
    return {}
  },
  methods:{
    emitChange(event){
      this.$emit("change-fixed-interest", event.target.value);
    }
  }
}
</script>

